import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { Heading, Paragraph } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import Managers from './Managers';
import Me from './Me';
import Managees from './Managees';

const Separator = styled(Box)`
	border-bottom: 1px dashed ${(props) => props.theme.colors.lightBlue};
`;

export default function Roles(props: { id: string }) {
	const { t } = useTranslation();
	const query = graphql.useUserManagersManageesQuery({
		variables: { id: props.id },
		fetchPolicy: 'network-only',
	});

	const user = query.data?.user;

	return (
		<Box mb={5} minWidth={200 + 180 * 2 + 8}>
			<Heading mb={2}>{t('settings.employees.roles.title')}</Heading>
			{user ? (
				<Paragraph mb={3}>
					{t('settings.employees.roles.description', { name: user.firstName })}
				</Paragraph>
			) : (
				<Paragraph.Skeleton lines={1} mb={3} />
			)}

			<Managers user={user as graphql.User} refetch={query.refetch} />

			<Separator my={4} />

			<Me user={user as graphql.User} />

			<Separator my={4} />

			<Managees user={user as graphql.User} refetch={query.refetch} />
		</Box>
	);
}
